<div class="container">
  <img class="illustration" src="{{data.imagePath}}">
  <div>
    <p class="prompt headline-regular">{{data.prompt}}</p>
    <p class="hint body-regular">{{data.hint}}</p>
  </div>
  <div class="button-container">
    <button *ngFor="let button of data.buttons" [ngClass]="setClass(button.type)" (click)="buttonClick(button)">{{button.text}}</button>
  </div>
</div>
